import { combineReducers } from "@reduxjs/toolkit";
import { titanApi } from "../services/API/titanApi";
import aashtoSlice from "./slices/aashtoSlice";
import aeussereSlice from "./slices/aeussereSlice";
import angepassteBemessungslastSlice from "./slices/angepassteBemessungslastSlice";
import authSlice from "./slices/auth/authSlice";
import belastungsartUndRichtungSlice from "./slices/belastungsartUndRichtungSlice";
import bemessungenMikropfaehleSlice from "./slices/bemessungenMikropfaehleSlice";
import bemessungslastGruppeGesamtSlice from "./slices/bemessungslastGruppeGesamtSlice";
import bemessungslastSlice from "./slices/bemessungslastSlice";
import bohrkronendurchmesserSlice from "./slices/bohrkronendurchmesserSlice";
import dataTablesSlice from "./slices/dataTablesSlice";
import deckblattSlice from "./slices/deckblattSlice";
import epdSlice from "./slices/epdSlice";
import fhwaSlice from "./slices/fhwaSlice";
import frontendZustandSlice from "./slices/frontendZustandSlice";
import innereSlice from "./slices/innereSlice";
import lvTextSlice from "./slices/lvTextSlice";
import pileHeadConstructionSlice from "./slices/pileHeadConstructionSlice";
import projectSlice from "./slices/projectSlice";
import selectedTraggliedSlice from "./slices/traggliedSlice";
import settingsSlice from "./slices/settingsSlice";
import appTitanSlice from "./slices/appTitanSlice";

const allReducers = combineReducers({
  selectedTragglied: selectedTraggliedSlice,
  bemessungslast: bemessungslastSlice,
  bohrkronendurchmesser: bohrkronendurchmesserSlice,
  belastungsartUndRichtung: belastungsartUndRichtungSlice,
  bemessungslastGruppeGesamt: bemessungslastGruppeGesamtSlice,
  bemessungenMikropfaehle: bemessungenMikropfaehleSlice,
  frontendZustand: frontendZustandSlice,
  angepassteBemessungslast: angepassteBemessungslastSlice,
  aeussere: aeussereSlice,
  innere: innereSlice,
  lvText: lvTextSlice,
  [titanApi.reducerPath]: titanApi.reducer,
  aashto: aashtoSlice,
  deckblatt: deckblattSlice,
  project: projectSlice,
  pileHeadConstruction: pileHeadConstructionSlice,
  auth: authSlice,
  datatables: dataTablesSlice,
  fhwa: fhwaSlice,
  settings: settingsSlice,
  appTitan: appTitanSlice,
  epd: epdSlice,
});

export default allReducers;
